// @flow

import {
  selectCartIsCommitted,
  selectCartUUID as selectCartId,
  selectOneProductById,
  type ProductId,
} from '@gandi/cart';

import { getSetupOverviewUrl } from 'src/Cart/Setup/modules/helpers';
import { selectIsFavoriteContacts } from 'src/Cart/Setup/modules/selectors';

import { useAppSelector } from 'src/hooks';

type Payload = {
  owner: any,
  admin?: any,
  tech?: any,
  bill?: any,
  ...
};

type ContactType = 'default' | 'favorite' | 'custom';

export type OwnProps = {
  productId: ProductId,
};

type StateProps = {
  committed: boolean,
  contactType: ContactType,
  contactsChangeURL: string,
};

const getContactType = (
  payload?: Payload,
  favoriteContacts: boolean,
): ContactType => {
  if (!payload || (!payload.bill && !payload.tech && !payload.admin)) {
    return 'default';
  }

  if (favoriteContacts) {
    return 'favorite';
  }

  return 'custom';
};

export const useDomainContacts = (props: OwnProps): StateProps => {
  const cartId = useAppSelector(selectCartId);
  const committed = useAppSelector(selectCartIsCommitted);
  const { process, payload } = useAppSelector(
    state =>
      selectOneProductById(state, props) || {
        process: undefined,
        payload: undefined,
      },
  );
  const isFavoriteContacts = useAppSelector(state =>
    process && (process === 'create' || process === 'transfer')
      ? selectIsFavoriteContacts(state, process)
      : false,
  );

  return {
    committed,
    contactType: getContactType(payload, isFavoriteContacts),
    contactsChangeURL: getSetupOverviewUrl(cartId, process),
  };
};
